module.exports = __webpack_public_path__ + "data/0962607.countries.geo.json";


//////////////////
// WEBPACK FOOTER
// ./client/app/visualizations/choropleth/countries.geo.json
// module id = 675
// module chunks = 1